export default "__VITE_ASSET__ced9a68b__"